import { render, staticRenderFns } from "./Protocolform.vue?vue&type=template&id=492d599d&"
import script from "./Protocolform.vue?vue&type=script&lang=js&"
export * from "./Protocolform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports